module.exports = __webpack_public_path__ + "media/Cs8.0f0c2d88.wav";